/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as browser from 'lib/Browser';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {FOLDER_ITEM_ICONS} from 'ui-library/icons/IconConstants';

interface SchemaIconProps {
  icon: BenchlingIconName;
}

function SchemaIcon({icon}: SchemaIconProps): JSX.Element {
  return (
    <BenchlingIcon
      icon={icon}
      ifIconMissingReason="Old client possibly attempting to access new schema icons"
      className="iconPicker-icon"
    />
  );
}

export interface IconPickerProps {
  folderItemType?: any; // TODO: PropTypes.oneOf([ '', ...TAG_SCHEMA_SUPPORTED_FOLDER_ITEM_TYPES, ModelTypeConstants.DNA_OLIGO, ])
  disabled: boolean;
  value: BenchlingIconName;
  onChange?: (...args: Array<any>) => any;
}

type IconPickerState = any;

class IconPicker extends React.Component<IconPickerProps, IconPickerState> {
  static defaultProps = {
    disabled: false,
  };

  namespace: any;

  state: IconPickerState = {
    isBeingEdited: false,
  };

  componentDidMount(): void {
    this.namespace = _.uniqueId('iconPicker-');
    if (browser.isBrowser) {
      $('body').on(`mousedown.${this.namespace}`, this.handleBodyMouseDown);
    }
  }

  componentWillUnmount(): void {
    if (browser.isBrowser) {
      $('body').off(`.${this.namespace}`);
    }
  }

  handleBodyMouseDown = (e: any): void => {
    if (!$.contains(ReactDOM.findDOMNode(this) as Element, e.target) && this.state.isBeingEdited) {
      this.setState({isBeingEdited: false});
    }
  };

  _toggleOpen = (): void => {
    this.setState({isBeingEdited: !this.state.isBeingEdited});
  };

  iconChangeHandler = (icon: any): void => {
    this.setState({isBeingEdited: false});
    this.props.onChange!({target: {value: icon}});
  };

  renderOptions = (): JSX.Element => {
    const icons = this.props.folderItemType
      ? FOLDER_ITEM_ICONS[this.props.folderItemType]
      : FOLDER_ITEM_ICONS[ModelTypeConstants.BASIC_FOLDER_ITEM];
    return (
      <table className="iconPicker-iconTable">
        <tbody>
          {icons.length <= 4 ? (
            <tr>
              {icons.map((icon: any, i: any) => (
                <td
                  className="iconPicker-iconCell"
                  key={icon}
                  onClick={this.iconChangeHandler.bind(this, icon)}
                >
                  <SchemaIcon icon={icon} />
                </td>
              ))}
            </tr>
          ) : (
            (() => {
              const result = [];
              for (let i = 0, end = icons.length; i < end; i += 4) {
                result.push(
                  <tr key={`row-${i}`}>
                    {[0, 1, 2, 3].map((j) =>
                      i + j < icons.length ? (
                        <td
                          className="iconPicker-iconCell"
                          key={icons[i + j]}
                          onClick={this.iconChangeHandler.bind(this, icons[i + j])}
                        >
                          <SchemaIcon icon={icons[i + j]} />
                        </td>
                      ) : (
                        <td className="iconPicker-emptyCell" key={`empty-${i + j}`} />
                      )
                    )}
                  </tr>
                );
              }
              return result;
            })()
          )}
        </tbody>
      </table>
    );
  };

  render(): JSX.Element {
    return (
      <div {...getTestProps({component: 'IconPicker', element: 'root'})}>
        <div
          className={classNames('iconPicker-editButton u-tiny-spacing-top', {
            'is-active': this.state.isBeingEdited,
            'is-disabled': this.props.disabled,
          })}
          onClick={!this.props.disabled ? this._toggleOpen : undefined}
        >
          <div className="iconPicker-selectedIconWrapper">
            <SchemaIcon icon={this.props.value} />
          </div>
          {!this.props.disabled && <BenchlingIcon icon="edit" className="iconPicker-editIcon" />}
        </div>
        {this.state.isBeingEdited ? (
          <div className="iconPicker-dropdown">{this.renderOptions()}</div>
        ) : undefined}
      </div>
    );
  }
}

export default IconPicker;
